import { render, staticRenderFns } from "./personal2-massage.vue?vue&type=template&id=40f67795&scoped=true&"
import script from "./personal2-massage.vue?vue&type=script&lang=js&"
export * from "./personal2-massage.vue?vue&type=script&lang=js&"
import style0 from "./personal2-massage.vue?vue&type=style&index=0&id=40f67795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f67795",
  null
  
)

export default component.exports